import { useQuery } from "@tanstack/react-query";
import { getOrganization, type Organization } from "../../api/private/getOrganization";
import { useToken } from "../../contexts/TokenContext";

export const useGetOrganization = () => {
  const { idToken } = useToken();

  return useQuery<Organization, Error>({
    queryKey: ["getOrganization", idToken],
    queryFn: () => getOrganization(idToken),
    enabled: false, // Manual trigger only
    retry: false,
  });
};
